import React, { Component } from "react";
import Toggle from "react-toggle-styled-component";
import { FieldName } from "../../theme/styled";

class CheckField extends Component {
  onChange = e => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.props.form.setFieldValue(name, value);
  };
  render() {
    const {
      label,
      field: { name, value = false },
    } = this.props;
    return (
      <div>
        <FieldName>{label}</FieldName>
        <label htmlFor={name} />
        <Toggle
          id={name}
          name={name}
          type="checkbox"
          checked={value}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

export default CheckField;
